module.exports = __webpack_public_path__ + "media/signup-react/money-3a1ac5b6.png";